import OpenSeadragon, { Options } from "openseadragon";

export interface ExtendedOptions extends Options {
  toolbar?: string; // This is missing for some reason
  pixelsPerMeter?: number;
  effectiveMagnification?: number;
}

// @ts-ignore (avif if not a key of `formats`, but we know we can force it in)
OpenSeadragon.setImageFormatsSupported({ jpeg: true, jpg: true, avif: true });

export class ExtendedSeadragonViewer extends OpenSeadragon.Viewer {
  private readonly pixelsPerMeter?: number;
  private readonly effectiveMagnification?: number;

  constructor(options: ExtendedOptions) {
    super(options); // Can call super() since above code does not reference this
    this.pixelsPerMeter = options.pixelsPerMeter;
    this.effectiveMagnification = options.effectiveMagnification;
  }

  getPixelsPerMeter(): number | undefined {
    return this.pixelsPerMeter;
  }

  zoomToEffectiveMagnification(magnificationWanted: number): void {
    const currentZoom = this.effectiveMagnification
      ? Number(
          (
            this.effectiveMagnification *
            this.viewport.viewportToImageZoom(this.viewport.getZoom())
          ).toFixed(2)
        )
      : this.viewport.getZoom();
    if (magnificationWanted !== currentZoom) {
      this.viewport.zoomTo(
        this.effectiveMagnification
          ? this.viewport.imageToViewportZoom(
              magnificationWanted / this.effectiveMagnification
            )
          : magnificationWanted,
        undefined,
        true
      );
    }
  }

  getZoomForBookmark(): number {
    return this.effectiveMagnification
      ? Number(
          (
            this.effectiveMagnification *
            this.viewport.viewportToImageZoom(this.viewport.getZoom())
          ).toFixed(2)
        )
      : this.viewport.getZoom();
  }
}

const factoryFunction = function (
  options: ExtendedOptions
): ExtendedSeadragonViewer {
  return new ExtendedSeadragonViewer(options);
};

export default factoryFunction;
